<template>
  <div class="data-manage">
    <div class="topTitle">
      <div style="flex: 1">
        <div style="margin-left: 32%; margin-top: 24px">
          <img :src="svg3" alt="" style="display: inline-block; margin-top: -36px" />
          <div style="display: inline-block; margin-left: 10px">
            <div class="topOne">当前站点名称</div>
            <div class="downOne" :title="param.siteName">{{ returnSiteName(param.siteName) }}</div>
          </div>
        </div>
      </div>
      <div class="content" style="flex: 1">
        <div class="drivers"></div>
        <div style="margin-left: 0%; margin-top: 24px">
          <img :src="svg6" alt="" style="display: inline-block; margin-top: -36px" />
          <div style="display: inline-block; margin-left: 10px">
            <div class="topOne">站点id</div>
            <div class="downOne">
              <a-dropdown>
                <a>
                  {{ param.siteId }}
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(item, index) in openItem" :key="index">
                    <a @click="openUrl(item)">{{ item }}</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <a
                href="javascript:;"
                v-clipboard:copy="param.siteId"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
              >
                <a-icon type="copy" :style="{ fontSize: '16px' }" />
              </a>
            </div>
          </div>
        </div>
        <div class="drivers"></div>
      </div>
      <div style="flex: 1">
        <div style="margin-left: 36%; margin-top: 24px">
          <img
            :src="svg2"
            alt=""
            style="display: inline-block; margin-top: -36px"
            v-if="param.currentStatus === 1"
          />
          <img
            :src="svg5"
            alt=""
            style="display: inline-block; margin-top: -36px"
            v-if="param.currentStatus === 0"
          />
          <img
            :src="svg1"
            alt=""
            style="display: inline-block; margin-top: -36px"
            v-if="param.currentStatus === 3"
          />
          <img
            :src="svg4"
            alt=""
            style="display: inline-block; margin-top: -36px"
            v-if="param.currentStatus === 2"
          />
          <div style="display: inline-block; margin-left: 10px">
            <div class="topOne">当前状态</div>
            <div class="downOne" style="color: #f5222d" v-if="param.currentStatus === 1">异常</div>
            <div class="downOne" style="color: #2fbb61" v-if="param.currentStatus === 0">正常</div>
            <div class="downOne" style="color: #ff9b25" v-if="param.currentStatus === 3">
              等待验证
            </div>
            <div class="downOne" style="color: #757575" v-if="param.currentStatus === 2">
              停止监控
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background: #ffffff">
      <a-tabs default-active-key="1" class="tabsOwn" @change="checkItem">
        <a-tab-pane key="1" tab="异常记录"></a-tab-pane>
        <a-tab-pane key="2" tab="站点配置"></a-tab-pane>
      </a-tabs>
      <star-condition-layout
        :onSearch="handleSearch"
        :onReset="reset"
        :loading="loading"
        ref="condition"
        v-show="check"
        class="layoutStyle"
      >
        <star-condition-cell label="处理状态">
          <a-select v-model="search.solveStatus" style="width: 100%">
            <!-- 正常、异常、停止监控、等待验证 -->
            <a-select-option value="全部"> 全部</a-select-option>
            <a-select-option :value="0"> 已忽略</a-select-option>
            <a-select-option :value="1"> 待处理</a-select-option>
            <a-select-option :value="2">已处理 </a-select-option>
          </a-select>
        </star-condition-cell>
        <star-condition-cell label="处理人员">
          <a-select
            v-model="search.userId"
            style="width: 100%"
            :filter-option="filterOption"
            show-search
          >
            <!-- <a-select-option value="人员1"> 人员1</a-select-option>
          <a-select-option value="人员2"> 人员2</a-select-option> -->
            <a-select-option value="全部"> 全部</a-select-option>
            <a-select-option v-for="(item, index) in peopleGroup" :key="index" :value="item.userId">
              {{ item.userName }}</a-select-option
            >
          </a-select>
        </star-condition-cell>

        <star-condition-cell label="处理时间">
          <a-range-picker
            style="width: 100%"
            v-model="search.publishTime"
            :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始日期', '结束日期']"
          />
        </star-condition-cell>
        <!-- <star-condition-cell> </star-condition-cell> -->
        <star-condition-cell label="检测时间">
          <a-range-picker
            style="width: 100%"
            v-model="search.publishTime1"
            :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始日期', '结束日期']"
          />
        </star-condition-cell>
      </star-condition-layout>
      <div v-show="!check">
        <a @click="editModeClick" v-show="!editMode" class="buttonEdit">
          <a-icon type="edit" />编辑</a
        >
        <InfoConfig ref="InfoConfig" v-show="!editMode"></InfoConfig>
        <CreateForm ref="CreateForm" v-if="editMode" @back="back"></CreateForm>
      </div>
    </div>

    <div class="table-wrap" v-show="check">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <!-- <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button> -->
      </TableHeadIcons>

      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="userId"
        :columns="showColumns"
        :dataSource="dataSource"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="status" slot-scope="text, record">{{
          record.status == '-1' ? '停用' : '启用 '
        }}</span>
        <span slot="userName" slot-scope="text">{{ text ? text : '--' }}</span>
        <span slot="exceptionCode" slot-scope="text, record">
          <a-tag color="blue">{{ record.exceptionCode }}</a-tag>
        </span>
        <!-- exceptionCode -->
        <span slot="preAlertsTime" slot-scope="text, record">{{
          record.preAlertsTime ? record.preAlertsTime + '~' + record.nextAlertsTime : ''
        }}</span>
        <span slot="solveStatus" slot-scope="text, record">
          <div style="display: flex" v-if="record.solveStatus == 2">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #1890ff;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>已处理</div>
          </div>
          <div style="display: flex" v-if="record.solveStatus == 1">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #f5222d;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>待处理</div>
          </div>
          <div style="display: flex" v-if="record.solveStatus == 0">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #ffa720;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>已忽略</div>
          </div>
        </span>
        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleStuteRz(record)" style="margin-right: 12px">
            处理日志
          </a>
          <a href="javascript:;" @click="handleEdit(record)" style="margin-right: 12px">
            异常任务
          </a>
          <a href="javascript:;" @click="handleStuteEdit(record)" style="margin-right: 12px">
            状态变更
          </a>
          <a href="javascript:;" @click="handleHandExec(record)"> 立即执行 </a>
        </div>
      </a-table>
    </div>
    <a-drawer
      :title="formModel == null ? '新增用户' : '修改用户'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>
    <ModelZT @reload="handleSearch" ref="ModelZT"></ModelZT>
    <ModelRZ ref="ModelRZ"></ModelRZ>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { queryUserApi, deleteUserApi } from '@/api/System/User'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { execNewsItemApi } from '@/api/Site/Manage'
import { exceptioninfo, crawlinfo, monitorUrl } from '@/api/Monitor/abnormal'
import { info } from '@/api/System/User'
// import moment from 'moment' exceptioninfo
import Form from './Form.vue'
import InfoConfig from './InfoConfig/index.vue'
import CreateForm from './CreateForm/index.vue'
import ModelZT from './modelZT.vue'
import ModelRZ from './modelRZ.vue'
import svg1 from './imgs/ddyz_sel.svg'
import svg2 from './imgs/dqzt_sel.svg'
import svg3 from './imgs/gs.svg'
import svg4 from './imgs/tzjk_sel.svg'
import svg5 from './imgs/zc_sel.svg'
import svg6 from './imgs/zdid_sel.svg'
import { domainToASCII } from 'url'

export default {
  data() {
    return {
      editMode: false,
      openItem: [],
      check: true,
      tableDensity: 'middle',
      loading: false,
      visible: false,
      spiderClassOptions: [],
      search: {
        publishTime: [],
        publishTime1: [],
        userId: '全部',
        solveStatus: '全部'
      },
      columns: [
        {
          width: 60,
          align: 'left',
          title: '序号',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '异常编号',
          show: true,
          dataIndex: 'exceptionCode',
          scopedSlots: { customRender: 'exceptionCode' }
        },
        {
          title: '检测时间',
          show: true,
          dataIndex: 'preAlertsTime',
          scopedSlots: { customRender: 'preAlertsTime' }
        },
        {
          title: '处理状态',
          show: true,
          dataIndex: 'solveStatus',
          scopedSlots: { customRender: 'solveStatus' }
        },
        {
          title: '处理人员',
          show: true,
          dataIndex: 'userDto.userName',
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: '处理时间',
          show: true,
          dataIndex: 'solveTime',
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: '操作',
          width: 290,
          show: true,
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      sorter: {},
      svg1,
      svg2,
      svg3,
      svg4,
      svg5,
      svg6,
      formModel: null,
      param: { currentStatus: 0, siteId: '' },
      peopleGroup: []
    }
  },
  created() {
    this.param = this.$route.query
    this.param.currentStatus = Number(this.param.currentStatus)
    this.getTableList()
    this.querySpiderClassInfo()
    this.leftData()

    if (
      this.param.siteType !== 'facebook' &&
      this.param.siteType !== 'twitter' &&
      this.param.siteType !== 'youtube' &&
      this.param.siteType !== 'weibo'
    ) {
      monitorUrl({ siteId: this.param.siteId, siteType: this.param.siteType }).then((res) => {
        this.openItem = res.data
      })
    } else {
      if (this.param.siteType === 'facebook') {
        let url = 'https://www.facebook.com/' + this.param.siteId.split('_')[2]
        this.openItem = [url]
      }
      if (this.param.siteType === 'twitter') {
        let url = 'https://twitter.com/' + this.param.siteId.split('_')[2]
        this.openItem = [url]
      }
      if (this.param.siteType === 'youtube') {
        let url = 'https://www.youtube.com/' + this.param.siteId.split('_')[2]
        this.openItem = [url]
      }
      if (this.param.siteType === 'weibo') {
        let url = 'https://www.weibo.com/' + this.param.siteId.split('_')[2]
        this.openItem = [url]
      }
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  mounted() {
    // :id="'spider_news_antdv'" :type="'news'" CreateForm
    // console.log(this.$route.query)
    this.$refs['InfoConfig'].sendData(this.$route.query.siteId, this.$route.query.siteType)
  },
  methods: {
    returnSiteName(item) {
      if (item) {
        if (item.length > 12) {
          const str = item.substring(0, 12)
          return str + '...'
        } else {
          return item
        }
      } else {
        return ''
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async leftData() {
      let query = {
        pn: 1,
        pageSize: 999999
      }
      this.loading = true
      let res = await queryUserApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      this.peopleGroup = data
    },
    editModeClick() {
      this.editMode = true
      this.$nextTick(() => {
        this.$refs['CreateForm'].sendData(this.$route.query.siteId, this.$route.query.siteType)
      })
    },
    back() {
      this.editMode = false
      this.$refs['InfoConfig'].reload()
    },
    checkItem(item) {
      if (item === '2') {
        this.check = false
      } else {
        this.check = true
      }
    },
    async handleHandExec(record) {
      // 弹框询问是否全量调度（全量调度不过滤系统中已存在的数据）
      const confirm = this.$confirm({
        content: '是否进行单次全量调度（全量调度不过滤系统中已存在的数据）',
        okText: '全量调度',
        cancelText: '非全量调度',
        maskClosable: true,
        centered: true,
        onOk: () => {
          this._handleHandExec(record, true)
        },
        onCancel: (e) => {
          if (typeof e === 'object' && e.triggerCancel) {
            confirm.destroy()
          } else {
            this._handleHandExec(record, false)
            return Promise.resolve()
          }
        }
      })
    },

    async _handleHandExec({ siteId }, isAll) {
      let res = await execNewsItemApi({
        spiderId: siteId,
        isAll
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },
    handleStuteEdit(record) {
      this.$refs.ModelZT.showModel(record)
    },
    handleStuteRz(record) {
      this.$refs.ModelRZ.showModel(record)
    },
    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    reset() {
      this.search = {
        publishTime: [],
        publishTime1: [],
        userId: '全部',
        solveStatus: '全部'
      }
      this.getTableList()
    },
    handleAdd() {
      this.formModel = null
      this.visible = true
    },

    handleEdit(record) {
      //       query: {
      //   spiderId: spiderId,
      //   errorStartTime: errorStartTime,
      //   errorEndTime: errorEndTime
      // }
      // console.log(record)
      window.open(
        `/#/dispatch_task_manage?spiderId=${this.param.siteId}&errorStartTime=${record.preAlertsTime}&errorEndTime=${record.nextAlertsTime}`
      )
      // this.formModel = record
      // this.visible = true
    },
    openUrl(item) {
      window.open(item)
    },
    async handleSearch() {
      /////////////////////////
      let query = {
        siteId: this.$route.query.siteId
      }
      let res = await crawlinfo(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == 200) {
        this.$router.push({
          path: 'monitor_gathererInfo',
          query: {
            monitorId: this.param.monitorId,
            siteId: this.param.siteId,
            siteName: this.param.siteName,
            currentStatus: data[0].currentStatus,
            siteType: this.param.siteType
          }
        })
        this.param.currentStatus = data[0].currentStatus
      } else {
        this.$message.error(msg)
      }

      /////////////

      this.pagination.current = 1
      this.getTableList()
    },

    handleRefresh() {
      this.pagination.current = 1
      this.visible = false
      this.getTableList()
    },

    handleReset() {
      this.search.userName = ''
      this.search.phone = ''
      this.search.mail = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete({ userId }) {
      const res = await deleteUserApi({ userId })
      const { code, msg } = res
      if (code == '200') {
        this.getTableList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },

    async getTableList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.search,
        monitorId: this.param.monitorId
      }
      for (let i in query) {
        if (query[i] === '全部') {
          query[i] = undefined
        }
      }
      delete query.publishTime
      delete query.publishTime1
      if (this.search.publishTime.length > 0) {
        query.startSolveTime = this.search.publishTime[0]
        query.endSolveTime = this.search.publishTime[1]
      }
      if (this.search.publishTime1.length > 0) {
        query.preAlertsTime = this.search.publishTime1[0]
        query.nextAlertsTime = this.search.publishTime1[1]
      }
      this.loading = true
      let res = await exceptioninfo(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == 200) {
        this.dataSource = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  },
  components: {
    Form,
    ModelZT,
    InfoConfig,
    CreateForm,
    ModelRZ
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;
  .topTitle {
    height: 106px;
    width: 100%;
    background: #ffffff;
    border-radius: 2px;
    margin-bottom: 16px;
    display: flex;
    // justify-content: space-between;
    .topOne {
      font-size: 14px;
      font-weight: 400;
      color: #a7a7a7;
    }

    .downOne {
      font-size: 24px;
      font-weight: 600;
      color: #343434;
    }
    .content {
      flex: 1;
      display: flex;
      justify-content: space-between;
      .drivers {
        margin-top: 24px;
        width: 1px;
        height: 58px;
        background: #e8e8e8;
      }
    }
  }
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    margin-top: 16px;
    background: #fff;
    padding: 0 20px 0 20px;
  }
}
.buttonEdit {
  position: absolute;
  right: 40px;
}
</style>
<style scoped>
.tabsOwn /deep/ .ant-tabs-ink-bar {
  left: 4px !important;
}
.tabsOwn /deep/ .ant-tabs-nav .ant-tabs-tab {
  margin: 0 4px 0 38px !important;
}
</style>
<style scoped>
.layoutStyle /deep/ .actions {
  width: 80px;
}
</style>
